export const USER_LIST = "USER_LIST";
